<template>
  <!--我的费用-->
  <div class="page-box">
    <h4 class="page-box__title">我的费用</h4>
    <el-form class=""
             :model="searchData"
             ref="searchForm"
             label-width="100px"
             :inline="true"
             @submit.native.prevent>
      <el-form-item label="运单号">
        <el-input v-model="searchData.nos"
                  size=""
                  class="edit-form__input"
                  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="主单号">
        <el-input v-model="searchData.mainnos"
                  size=""
                  class="edit-form__input"
                  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="费用名称">
        <el-select v-model="searchData.feeitemid"
                   size=""
                   class="edit-form__input"
                   placeholder="请选择">
          <el-option
            v-for="(item, index) in feeItemNameList"
            :key="index"
            :label="item.feeitemName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!--<el-form-item label="费用状态">-->
        <!--<el-select v-model="searchData.processstatusdec"-->
                   <!--size=""-->
                   <!--class="edit-form__input"-->
                   <!--placeholder="请选择">-->
          <!--<el-option-->
            <!--v-for="(item, index) in feeStatusList"-->
            <!--:key="index"-->
            <!--:label="item.name"-->
            <!--:value="item.name"-->
          <!--&gt;</el-option>-->
        <!--</el-select>-->
      <!--</el-form-item>-->
      <el-form-item label="费用产生时间">
        <el-date-picker v-model="startDateValue"
                        @change="changeStartDateValue"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item label=" " label-width="10px">
        <el-button type="primary"
                   icon="el-icon-search"
                   @click="search">查询
        </el-button>
      </el-form-item>
    </el-form>
    <div class=""
         style="margin: 30px auto 15px;">
      <!--<el-button :disabled="tableDataSelectValue.length<=0"-->
                 <!--@click="clickConfirmOrder"-->
                 <!--type="primary">确认-->
      <!--</el-button>-->
      <!--<el-button :disabled="tableDataSelectValue.length<=0"-->
                 <!--type="danger"-->
                 <!--@click="clickRejectOrder"-->
                 <!--style="margin-left: 20px;">拒绝-->
      <!--</el-button>-->
      <el-button :disabled="tableDataSelectValue.length<=0"
                 type=""
                 @click="clickCreateOrder">生产账单
      </el-button>
    </div>
    <el-table :data="tableData"
              @selection-change="selectionChangeValue"
              align="center"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              size="mini">
      <el-table-column label=""
                       type="selection"
                       header-align="center"
                       align="center"
                       width="50"></el-table-column>
      <el-table-column label="序号"
                       type="index"
                       align="center"
                       width="60"></el-table-column>
      <el-table-column label="运单号"
                       align="center"
                       min-width="130"
                       prop="nos"></el-table-column>
      <el-table-column label="主单号"
                       align="center"
                       min-width="130"
                       prop="mainnos"></el-table-column>
      <el-table-column label="费用名称"
                       align="center"
                       min-width="130"
                       prop="feeitemdec"></el-table-column>
      <el-table-column label="费用产生时间"
                       align="center"
                       min-width="130"
                       prop="arapdate"></el-table-column>
      <el-table-column label="实际数量"
                       align="center"
                       min-width="130"
                       prop="actualPiece"></el-table-column>
      <el-table-column label="计费数量"
                       align="center"
                       min-width="130"
                       prop="piece"></el-table-column>
      <el-table-column label="单价"
                       align="center"
                       min-width="130"
                       prop="pricenotax"></el-table-column>
      <el-table-column label="费用金额"
                       align="center"
                       min-width="130"
                       prop="amount"></el-table-column>
      <el-table-column label="折合人名币"
                       align="center"
                       min-width="130"
                       prop="cnyAmount"></el-table-column>
      <el-table-column label="计费过程"
                       align="center"
                       min-width="130"
                       prop="calDesc"></el-table-column>
      <el-table-column label="备注"
                       align="center"
                       min-width="130"
                       prop="remarks"></el-table-column>
      <el-table-column label="费用来源"
                       align="center"
                       min-width="130"
                       prop="feesourcedec"></el-table-column>
      <!--<el-table-column label="操作"-->
      <!--min-width="120"-->
      <!--fixed="right"-->
      <!--align="left">-->
      <!--<template slot-scope="scope"></template>-->
      <!--</el-table-column>-->
    </el-table>

    <el-dialog title=""
               width="600px"
               custom-class="edit-dialog"
               :visible.sync="visibleEditForm"
               :close-on-press-escape="false"
               :close-on-click-modal="false">
      <el-form class=""
               :model="editFormData"
               ref="editForm"
               label-width="120px"
               :inline="true"
               @submit.native.prevent>
        <el-form-item label="账单号号"
                      prop="billNumber"
                      :rules="formRules.require">
          <el-input v-model="editFormData.billNumber"
                    :disabled="true"
                    size="mini"
                    class="edit-form__input"
                    placeholder="请输入"></el-input>
        </el-form-item>
        <br/>
        <el-form-item label="对账日期："
                      prop="bill_check_time"
                      :rules="formRules.require">
          <el-date-picker placeholder="请选择"
                          class="edit-form__input"
                          size="mini"
                          v-model="editFormData.bill_check_time"
                          align="right"
                          type="date"
                          value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <br/>
        <el-form-item label="账期："
                      prop="billdate_end"
                      :rules="formRules.require">
          <el-date-picker v-model="saveTimeValue"
                          @change="changeSaveTimeValue"
                          size="small"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder=""
                          end-placeholder=""
                          clearable>
          </el-date-picker>
        </el-form-item>
        <br/>
        <el-form-item label=" " style="margin-top: 30px;">
          <el-button type=""
                     @click="hideEditForm">取消
          </el-button>
          <el-button type="primary"
                     @click="clickSave()"
                     style="margin-left: 30px;">确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {pagingMixins} from "@/assets/js/pagingMixins";

  function baseDataEditFromData() {
    return {
      "arapIds": [], // 费用id数组
      "billNumber": "", // 账单号
      "bill_check_time": "",  // 账单对账日期
      "billdate_end": "", // 账单到
      "billdate_start": ""  //账单从
    }
  }
  export default {
    name: "myCost",
    mixins: [pagingMixins],
    data() {
      return {
        /* 筛选 */
        searchData: {
          arapDateEnd: '',// 费用产生结束时间
          arapDateStart: '', // 费用产生开始时间
          feeitemid: '', // 费用名称id
          mainnos: '', // 主单号
          nos: '', // 运单号
          processstatusdec: '', // 费用状态
        },
        /* 选择框 数据 */
        startDateValue: [],
        saveTimeValue:[],
        feeStatusList: [
          {name: '全部'},
          {name: '待运力商确认'},
          {name: '运力商已拒绝'},
          {name: '已生效'},
          {name: '待平台确认'},
          {name: '平台已拒绝'},
        ],
        feeItemNameList: [],//费用名称下拉框接口
        /* 编辑弹窗 */
        visibleEditForm: false,
        editFormData: baseDataEditFromData(),
      }
    },
    created() {
      this.getFeeItemNameList();
      this.getList();
    },
    methods: {
      /**
       * 获取 获取费用名称下拉框接口
       */
      getFeeItemNameList() {
        this.loading = true;
        return new Promise((resolve, reject) => {
          this.axios.post('/arapcost/getCostNameList')
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.feeItemNameList = [];
                this.$message.info(res.data.message || "服务器繁忙");
                return false;
              }
              this.feeItemNameList = res.data.datas;
              resolve(res);
            })
            .catch((res) => {
              this.loading = false;
              this.feeItemNameList = [];
            });
        })
      },
      /**
       * 获取 列表
       */
      getList() {
        let data = this.jointSearchData();
        this.loading = true;
        return new Promise((resolve, reject) => {
          this.axios.post('/arapcost/getMyCostList', data)
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.tableData = [];
                this.$message.info(res.data.message || "服务器繁忙");
                return false;
              }
              this.tableData = res.data.datas;
              resolve(res);
            })
            .catch((res) => {
              this.loading = false;
              this.tableData = [];
            });
        })
      },
      /*查询时间*/
      changeStartDateValue(value) {
        if (!value) value = [];
        this.searchData.arapDateStart = value[0];
        this.searchData.arapDateEnd = value[1];
      },
      changeSaveTimeValue(value) {
        if (!value) value = [];
        this.editFormData.billdate_start = value[0]||'';
        this.editFormData.billdate_end = value[1]||'';
      },
      /**
       * 点击 确认
       */
      clickConfirmOrder(){
        let judge = this.tableDataSelectValue.every(res=>{
          return res.processstatusdec === '待运力商确认'
        });
        if(!judge) return this.$message.error('只能勾选状态为【待运力商确认】的费用项');
        this.$confirm('此操作确认勾选的费用项, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.editOrderStatus('Y')
        }).catch(() => {

        });
      },
      /**
       * 点击 拒绝
       */
      clickRejectOrder(){
        let judge = this.tableDataSelectValue.every(res=>{
          return res.processstatusdec === '待运力商确认'
        });
        if(!judge) return this.$message.error('只能勾选状态为【待运力商确认】的费用项');
        this.$confirm('此操作确认勾选的费用项, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.editOrderStatus('LR')
        }).catch(() => {

        });
      },
      /**
       * 费用确认接口
       * @param status {string} 费用状态Y：确认 LR：拒绝
       */
      editOrderStatus(status = ''){
        if(!status) return false;
        let data = {
          // ArapProcessStatus:status,
          arapIds:this.selectValueIds,
        };
        return new Promise((resolve, reject) => {
          this.loading = true;
          this.axios.post('/arapcost/updateFinaArapBillidById?ArapProcessStatus='+status,data,{
            headers:{"Content-Type":"application/json",},
          })
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.$message.info(res.data.message || "服务器繁忙");
                return false;
              }
              this.getList();
              resolve(res);
            })
            .catch((res) => {
              this.loading = false;
            });
        })
      },
      /**
       * 点击 生成账单
       */
      clickCreateOrder(){
        // let judge = this.tableDataSelectValue.every(res=>{
        //   return res.processstatusdec === '已生效'
        // });
        // if(!judge) return this.$message.error('只能勾选状态为【已生效】的费用项');
        this.createOrderId().then(id=>{
          this.editFormData.billNumber = id;
          this.showEditForm();
        }).catch(res=>{

        });
        this.showEditForm();
      },
      /**
       * 生成账单号
       */
      createOrderId(){
        return new Promise((resolve, reject) => {
          this.loading = true;
          this.axios.post('/arapcost/getBillNumber')
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.$message.info(res.data.message || "服务器繁忙");
                return false;
              }
              let data= res.data.datas;
              if(data instanceof Array && data[0] && data[0].billNumber){
                resolve(data[0].billNumber);
              }else{
                this.$message.info("获取账单号：服务器繁忙");
              }
            })
            .catch((res) => {
              this.loading = false;
            });
        })
      },
      /**
       * 点击保存
       */
      clickSave(formName = 'editForm'){
        this.$refs[formName].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.submitSave().then(res=>{
            this.hideEditForm();
            this.getList();
          });
        });
      },
      submitSave(){
        let data = Object.assign({},this.editFormData);
        data.arapIds = this.selectValueIds;
        return new Promise((resolve, reject) => {
          this.loading = true;
          this.axios.post('/arapcost/updateBillidById',data)
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.$message.info(res.data.message || "服务器繁忙");
                return false;
              }
              resolve();
            })
            .catch((res) => {
              this.loading = false;
            });
        })
      },
    },
    computed: {
      /**
       * 勾选项是否可以生产账单
       */
      selectValueIds(){
        return this.tableDataSelectValue.map(res=>res.id);
      },
    },
    watch:{
      visibleEditForm(newValue){
        if(!newValue) this.editFormData = baseDataEditFromData();
      }
    }
  }
</script>

<style scoped>
  .edit-form__input {

  }
</style>



// WEBPACK FOOTER //
// src/components/financialManagement/myCost.vue